import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {

  extractCsvToJson(csv: any) {
    const lines = csv.split('\n');
    const result: any[] = [];
    const headers = lines[0].split(',');
    for (let i = 1; i < lines.length; i++) {
      const obj = {};
      const currentline = lines[i].split(',');
      for (let j = 0; j < headers.length; j++) {
        const key = headers[j].trim();
        const value: string = currentline[j];
        obj[key] = value;
      }

      result.push(obj);
    }

    return JSON.parse(JSON.stringify(result));
  }

  cleanStrValue(char: string) {
    return char.replace('\r\n', '').replace('\r', '').replace('\n', '').trim();
  }
}
